import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NgOptimizedImage, NgTemplateOutlet} from '@angular/common';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {MatDivider} from '@angular/material/divider';
import {TextButtonComponent} from '@aviary/buttons/text-button/text-button.component';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';
import {ArrowTextButtonComponent} from '@lib/components/arrow-text-button/arrow-text-button.component';

@Component({
  selector: 'px-footer',
  host: {
    class: 'flex flex-col bg-surface2'
  },
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, SelectPipe, MatDivider, NgTemplateOutlet, TextButtonComponent, ButtonRouteNameDirective, ArrowTextButtonComponent]
})
export class FooterComponent {
  public readonly organizationSelectors = OrganizationSelectors.Auth;
  public readonly patronSelectors = PatronSelectors.Auth;
  public readonly viewportSelectors = ViewportSelectors;
  public readonly currentYear = (new Date().getFullYear()).toString();
}
